import React, { useState} from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { CircularProgress } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import logoWhite from "./images/K-Brielly logo.png";

import SnackBar from "./CustomizedSnackbar";
//import LOGO from "./images/K-Brielly logo.png"
import backgroundShape from "./images/headphones.jpg";

import firebase from "./firebase/firebase";
import "firebase/firestore";
import "firebase/auth";


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  avatar: {
    margin: theme.spacing(),
    padding: theme.spacing(),
    backgroundColor: "#FCFCFC",
    alignItems:"center"
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  submit: {
    marginTop: theme.spacing(3),
    backgroundColor:"#353532"
  },
  Bacground:{
    background: `url(${backgroundShape}) no-repeat`,
    backgroundSize: "cover",}
    ,
      bar: {
        backgroundColor: "#34495E ",
        height: 70,
        position: "relative",
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.grey["100"]}`
      },
      flex: {
        display: "flex",
        alignItems: "center",
        responsive: "scroll"
    },
    appBar:{
      background:"Black",
      elevation:0
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Login(props) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [open, setOpen] = React.useState(false);

  const [snackbarMessage, setsnackbarMessage] = useState();
  const [snackbarVariant, setsnackbarVariant] = useState();
  const [snackbarTrigger, setsnackbarTrigger] = useState();

  const onSnackbarClose = () => {
    setsnackbarTrigger(false);
  };

  const triggerSnackbar = (message, variant) => {
    setsnackbarMessage(message);
    setsnackbarVariant(variant);
    setsnackbarTrigger(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };



  const login = e => {
    e.preventDefault();
    setOpen(true);
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(user => {
        setEmail(email);
        setOpen(false);
        window.location.href = "/upload";
      })
      .catch(error => {
        triggerSnackbar("Login "+error, "error");
      });
  };
  

  const emailChange = e => {
    setEmail(e.target.value);
    setErrorEmail(
      email
        ? /\S+@\S+\.\S+/.test(email)
          ? ""
          : "Invalid email address" + errorEmail
        : "Please provide your email address"
    );

  };
  const passChange = e => {
    setPassword(e.target.value);
  };

  const back=e=>{
    window.location.href="/"
  }

  return (
    <div className={classes.Bacground} style={{
      paddingBottom:200,
      
    }}>
     <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
    <Grid >
        <Container
          component="main"
          maxWidth="xs"
        >
          
          <div className={classes.root}>
            <Paper className={classes.paper}>
            <Typography component="h5" variant="h5">
              Sign in
            </Typography>
            <Avatar className={classes.avatar}  alt="logo" src={logoWhite} />
            <form noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={emailChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={passChange}
              />
              
              <Button
                type="submit"
                className={classes.submit}
                fullWidth
                variant="contained"
                color="primary"
                onClick={login}
              >
                {" "}
                Sign In
              </Button>
            </form>
            <Button
                type="submit"
                className={classes.submit}
                fullWidth
                variant="contained"
                color="primary"
                onClick={back}
              >
                {" "}
                Cancel
              </Button>
            </Paper>
          </div>
        </Container>
        <SnackBar
            message={snackbarMessage}
            trigger={snackbarTrigger}
            variant={snackbarVariant}
            onClose={onSnackbarClose}
        />
        <Dialog
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title">{"logging you in..."}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container justify="center">
            <CircularProgress color="secondary"/>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </Grid>
    </div>
  );
}
